import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayModule } from '@angular/cdk/overlay';
import { RouterModule } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { AtlasMenuComponent } from '@app/components/widgets/atlas-menu/atlas-menu.component';
import { BreadcrumbsComponent } from '@app/components/widgets/breadcrumbs/breadcrumbs.component';
import { DocumentSecurityTableComponent } from '@app/components/widgets/document-security-table/document-security-table.component';
import { UserGroupComboComponent } from '@app/components/widgets/user-group-combo/user-group-combo.component';
import { MatDividerModule } from '@angular/material/divider';
import { LocalStorageService } from '@app/services/local-storage.service';
import { TransformPathPipe } from '@app/pipes/transform-path.pipe';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        OverlayModule,
        RouterModule,
        MatButtonModule,
        MatToolbarModule,
        MatSelectModule,
        MatTabsModule,
        MatInputModule,
        MatChipsModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatSidenavModule,
        MatCheckboxModule,
        MatListModule,
        MatMenuModule,
        MatIconModule,
        MatTooltipModule,
        MatDialogModule,
        MatTableModule,
        MatGridListModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatSortModule,
        MatTreeModule,
        OverlayModule,
        MatSlideToggleModule,
        MatProgressBarModule,
        MatStepperModule,
        MatRadioModule,
        ReactiveFormsModule,
        MatAutocompleteModule,
        MatMomentDateModule,
        MatDatepickerModule,
        MatSliderModule,
        MatBadgeModule,
        MatExpansionModule,
        MatDividerModule
    ],
    declarations: [
        AtlasMenuComponent,
        BreadcrumbsComponent,
        DocumentSecurityTableComponent,
        UserGroupComboComponent,
        TransformPathPipe
    ],
    exports: [
        CommonModule,
        FormsModule,
        OverlayModule,
        RouterModule,
        MatButtonModule,
        MatMenuModule,
        MatTabsModule,
        MatChipsModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatCardModule,
        MatSidenavModule,
        MatListModule,
        MatSelectModule,
        MatToolbarModule,
        MatIconModule,
        MatTooltipModule,
        MatDialogModule,
        MatTableModule,
        MatGridListModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatSortModule,
        MatTreeModule,
        OverlayModule,
        MatSlideToggleModule,
        MatProgressBarModule,
        MatStepperModule,
        ReactiveFormsModule,
        MatRadioModule,
        MatAutocompleteModule,
        MatMomentDateModule,
        MatDatepickerModule,
        MatSliderModule,
        MatBadgeModule,
        MatBottomSheetModule,
        MatExpansionModule,
        AtlasMenuComponent,
        BreadcrumbsComponent,
        DocumentSecurityTableComponent,
        UserGroupComboComponent,
        TransformPathPipe
    ],
    providers: [LocalStorageService]
})
export class SharedModule {
}
